/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:46:03
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-05-19 15:46:04
 */

import Market from './Market';

export interface IUrlList {
  urls: string[];
}

export interface ICookieInfo {
  url: string;
  cookieName: string;
}

const TBSManage = {
  AddInAppPopupUrls: (params: IUrlList): Promise<{}> => Market.__asyncCallApi('TBSManage.AddInAppPopupUrls', params || {}),
  ClearInAppPopupUrls: (): Promise<{}> => Market.__asyncCallApi('TBSManage.ClearInAppPopupUrls', {}),
  AddInAppPopupHostUrls: (urls: string[]): Promise<{}> => Market.__asyncCallApi('TBSManage.AddInAppPopupHostUrls', { urls: urls || [] }),
  ClearInAppPopupHostUrls: (): Promise<{}> => Market.__asyncCallApi('TBSManage.ClearInAppPopupHostUrls', {}),
  DeleteCookie: (params: ICookieInfo): Promise<{}> => Market.__asyncCallApi('TBSManage.DeleteCookie', params || {}),
};

export default TBSManage;
